// extracted by mini-css-extract-plugin
module.exports = {"buoySwell":"BuoySwell_buoySwell__Zp7Pv"};